// Cache pour les données préchargées (JSON)
                window.quickDrawerCache = window.quickDrawerCache || {};
                
                // Précharger au survol - utilise l'API JSON (plus rapide)
                function preloadProductData(url) {
                  if (!url || window.quickDrawerCache[url]) return;
                  
                  // Extraire le handle du produit
                  var urlParts = url.split('/');
                  var productHandle = urlParts[urlParts.indexOf('products') + 1];
                  if (productHandle && productHandle.includes('?')) {
                    productHandle = productHandle.split('?')[0];
                  }
                  if (!productHandle) return;
                  
                  window.quickDrawerCache[url] = 'loading';
                  
                  fetch('/products/' + productHandle + '.json')
                    .then(function(res) { return res.json(); })
                    .then(function(data) {
                      window.quickDrawerCache[url] = data.product;
                    })
                    .catch(function() {
                      delete window.quickDrawerCache[url];
                    });
                }
                
                // Attacher le préchargement aux cartes produits
                document.addEventListener('DOMContentLoaded', function() {
                  document.querySelectorAll('.card, .card-wrapper').forEach(function(card) {
                    card.addEventListener('mouseenter', function() {
                      var btn = this.querySelector('[data-product-url]');
                      if (btn) {
                        preloadProductData(btn.dataset.productUrl);
                      }
                    }, { once: true });
                  });
                });
                
                if (typeof window.openQuickDrawer === 'undefined') {
                window.openQuickDrawer = function(btn) {
                  event.preventDefault();
                  var url = btn.dataset.productUrl;
                  var title = btn.dataset.productTitle;
                  var image = btn.dataset.productImage;
                  var price = btn.dataset.productPrice;
                  var comparePrice = btn.dataset.productComparePrice;
                  var hasCompare = btn.dataset.productHasCompare === 'true';
                  var promoEuros = btn.dataset.productPromo;
                  
                  // Créer le drawer s'il n'existe pas
                  if (!document.getElementById('quick-drawer-global')) {
                    var drawerHTML = '<div id="quick-drawer-overlay"></div>' +
                      '<div id="quick-drawer-global">' +
                        '<div class="quick-drawer-header">' +
                          '<span>CHOISIR LES OPTIONS</span>' +
                          '<button class="quick-drawer-close" onclick="window.closeQuickDrawer()">&times;</button>' +
                        '</div>' +
                        '<div class="quick-drawer-content">' +
                          '<div class="quick-drawer-product"></div>' +
                          '<div class="quick-drawer-form"></div>' +
                        '</div>' +
                      '</div>';
                    document.body.insertAdjacentHTML('beforeend', drawerHTML);
                    document.getElementById('quick-drawer-overlay').addEventListener('click', window.closeQuickDrawer);
                  }
                  
                  var drawer = document.getElementById('quick-drawer-global');
                  var overlay = document.getElementById('quick-drawer-overlay');
                  var productDiv = drawer.querySelector('.quick-drawer-product');
                  var formDiv = drawer.querySelector('.quick-drawer-form');
                  
                  // Stocker l'URL du produit courant
                  drawer.setAttribute('data-current-url', url);
                  
                  // Afficher info produit avec promo
                  var priceHTML = '';
                  if (hasCompare && comparePrice) {
                    priceHTML = '<span class="compare-price" style="text-decoration:line-through;color:#999;margin-right:8px;">' + comparePrice + '</span>';
                  }
                  priceHTML += '<span class="price" style="color:#e53935;font-weight:600;">' + price + '</span>';
                  
                  // Badge promo
                  var promoHTML = '';
                  if (promoEuros) {
                    promoHTML = '<div style="margin-top:8px;"><span class="promo-badge-drawer" style="background:#000;color:#fff;font-size:11px;font-weight:600;padding:4px 10px;text-transform:uppercase;">Économiser ' + promoEuros + '€</span></div>';
                  }
                  
                  productDiv.innerHTML = '<img src="' + image + '" alt="' + title + '">' +
                    '<div class="quick-drawer-product-info">' +
                      '<h3>' + title + '</h3>' +
                      '<div class="drawer-price-container">' + priceHTML + '</div>' +
                      promoHTML +
                      '<a href="' + url + '" class="view-details">Voir les détails</a>' +
                    '</div>';
                  
                  drawer.classList.add('open');
                  overlay.classList.add('open');
                  document.body.style.overflow = 'hidden';
                  
                  // Fonction pour afficher le formulaire
                  function displayProductForm(product) {
                      window.quickDrawerVariants = product.variants;
                      
                      // Générer le formulaire
                      var formHTML = '';
                      
                      // Générer les options (Couleur, Taille, etc.)
                      if (product.options && product.options.length > 0) {
                        product.options.forEach(function(option, optIndex) {
                          if (option.name.toLowerCase() === 'title' && option.values.length === 1 && option.values[0] === 'Default Title') {
                            return; // Ignorer l'option par défaut
                          }
                          
                          formHTML += '<div class="product-form__input">';
                          formHTML += '<fieldset class="js product-form__input--pill">';
                          formHTML += '<legend class="form__label">' + option.name + ': <span style="font-weight:normal;margin-left:5px;">' + option.values[0] + '</span></legend>';
                          
                          // Ajouter le guide des tailles après Taille
                          if (option.name.toLowerCase().includes('taille') || option.name.toLowerCase().includes('size')) {
                            formHTML += '<button type="button" onclick="loadSizeGuide(\'' + url + '\')" class="size-guide-link" style="display:inline-flex;align-items:center;gap:6px;margin-top:8px;margin-bottom:15px;font-size:13px;color:#4a90d9;background:#f0f7ff;border:1px solid #d0e3f7;border-radius:20px;padding:8px 15px;cursor:pointer;">📏 Guide des tailles</button>';
                          }
                          
                          formHTML += '<div class="product-form__input--options">';
                          
                          option.values.forEach(function(value, valIndex) {
                            var inputId = 'drawer-option-' + optIndex + '-' + valIndex;
                            var isColor = option.name.toLowerCase().includes('couleur') || option.name.toLowerCase().includes('color');
                            var checked = valIndex === 0 ? 'checked' : '';
                            
                            formHTML += '<input type="radio" id="' + inputId + '" name="option' + optIndex + '" value="' + value + '" ' + checked + ' style="display:none;">';
                            
                            if (isColor) {
                              // Trouver l'image de variante pour cette couleur
                              var variantImage = '';
                              
                              // Méthode 1: Chercher une variante avec cette couleur et son image_id
                              for (var vi = 0; vi < product.variants.length; vi++) {
                                var v = product.variants[vi];
                                if (v.option1 === value || v.option2 === value || v.option3 === value) {
                                  if (v.image_id && product.images) {
                                    // Trouver l'image correspondante par image_id
                                    for (var ii = 0; ii < product.images.length; ii++) {
                                      if (product.images[ii].id === v.image_id) {
                                        variantImage = product.images[ii].src;
                                        break;
                                      }
                                    }
                                  }
                                  if (variantImage) break;
                                }
                              }
                              
                              // Méthode 2: Si pas d'image trouvée, utiliser l'image par défaut
                              if (!variantImage && product.images && product.images[0]) {
                                variantImage = product.images[0].src;
                              }
                              
                              formHTML += '<label for="' + inputId + '" class="color-swatch' + (valIndex === 0 ? ' selected' : '') + '" title="' + value + '" data-variant-img="' + variantImage + '" style="display:inline-flex;align-items:center;justify-content:center;width:55px;height:55px;border-radius:50%;cursor:pointer;border:3px solid ' + (valIndex === 0 ? '#000' : '#ddd') + ';margin:5px;background:#f5f5f5;box-sizing:border-box;padding:3px;"><span style="display:block;width:100%;height:100%;border-radius:50%;background-size:cover;background-position:center;background-image:url(\'' + variantImage + '\');"></span></label>';
                            } else {
                              formHTML += '<label for="' + inputId + '" class="size-option' + (valIndex === 0 ? ' selected' : '') + '" style="display:inline-block;padding:10px 16px;border-radius:8px;cursor:pointer;border:2px solid ' + (valIndex === 0 ? '#000' : '#ddd') + ';margin:4px;font-size:13px;background:' + (valIndex === 0 ? '#000' : '#fff') + ';color:' + (valIndex === 0 ? '#fff' : '#333') + ';">' + value + '</label>';
                            }
                          });
                          
                          formHTML += '</div></fieldset></div>';
                        });
                      }
                      
                      // Si pas d'option Taille, ajouter le guide après les couleurs
                      var hasSizeOption = product.options && product.options.some(function(o) {
                        return o.name.toLowerCase().includes('taille') || o.name.toLowerCase().includes('size');
                      });
                      if (!hasSizeOption) {
                        formHTML += '<div class="size-guide-container"><button type="button" onclick="loadSizeGuide(\'' + url + '\')" class="size-guide-link" style="display:inline-flex;align-items:center;gap:6px;margin-bottom:15px;font-size:13px;color:#4a90d9;background:#f0f7ff;border:1px solid #d0e3f7;border-radius:20px;padding:8px 15px;cursor:pointer;">📏 Guide des tailles</button></div>';
                      }
                      
                      // Précharger le guide des tailles en arrière-plan
                      window.sizeGuideCache = window.sizeGuideCache || {};
                      if (!window.sizeGuideCache[url]) {
                        fetch(url).then(function(res) { return res.text(); }).then(function(html) {
                          window.sizeGuideCache[url] = html;
                        });
                      }
                      
                      // Trouver la première variante disponible
                      var firstVariant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
                      
                      // Créer le formulaire
                      formDiv.innerHTML = '<form action="/cart/add" method="post" accept-charset="UTF-8" enctype="multipart/form-data" data-type="add-to-cart-form">' +
                        '<input type="hidden" name="id" value="' + firstVariant.id + '">' +
                        formHTML +
                        '<div style="margin-top:20px;">' +
                          '<button type="submit" name="add" class="product-form__submit button button--full-width" style="width:100%;padding:18px;background:#000;color:#fff;border:none;cursor:pointer;font-size:14px;font-weight:600;text-transform:uppercase;letter-spacing:1px;border-radius:4px;">Ajouter au panier</button>' +
                        '</div>' +
                        '</form>';
                      
                      // Attacher les événements de sélection aux labels
                      formDiv.querySelectorAll('.color-swatch, .size-option').forEach(function(label) {
                        label.addEventListener('click', function(e) {
                          e.preventDefault();
                          e.stopPropagation();
                          
                          var inputId = this.getAttribute('for');
                          var radio = formDiv.querySelector('#' + inputId);
                          if (!radio) return;
                          
                          var name = radio.name;
                          var isColor = this.classList.contains('color-swatch');
                          
                          // Désélectionner tous les labels du même groupe
                          formDiv.querySelectorAll('input[name="' + name + '"]').forEach(function(r) {
                            var lbl = formDiv.querySelector('label[for="' + r.id + '"]');
                            if (lbl) {
                              lbl.classList.remove('selected');
                              lbl.style.borderColor = '#ddd';
                              if (!lbl.classList.contains('color-swatch')) {
                                lbl.style.background = '#fff';
                                lbl.style.color = '#333';
                              }
                            }
                          });
                          
                          // Sélectionner celui-ci
                          radio.checked = true;
                          this.classList.add('selected');
                          this.style.borderColor = '#000';
                          if (!isColor) {
                            this.style.background = '#000';
                            this.style.color = '#fff';
                          }
                          
                          // Changer l'image produit dans le drawer au clic sur une couleur
                          if (isColor) {
                            var newImg = this.getAttribute('data-variant-img');
                            if (newImg) {
                              var drawerImg = drawer.querySelector('.quick-drawer-product img');
                              if (drawerImg) drawerImg.src = newImg;
                            }
                          }
                          
                          // Mettre à jour le texte de la légende
                          var fieldset = this.closest('fieldset');
                          if (fieldset) {
                            var legend = fieldset.querySelector('legend');
                            if (legend) {
                              var optName = legend.textContent.split(':')[0];
                              legend.innerHTML = optName + ': <span style="font-weight:normal;margin-left:5px;">' + radio.value + '</span>';
                            }
                          }
                          
                          // Mettre à jour l'ID de variante
                          updateDrawerVariant();
                        });
                      });
                      
                      function updateDrawerVariant() {
                        var selectedOptions = [];
                        product.options.forEach(function(opt, idx) {
                          var checked = formDiv.querySelector('input[name="option' + idx + '"]:checked');
                          if (checked) {
                            selectedOptions.push(checked.value);
                          }
                        });
                        
                        // Trouver la variante correspondante
                        var variant = product.variants.find(function(v) {
                          return selectedOptions.every(function(opt, idx) {
                            return v['option' + (idx + 1)] === opt;
                          });
                        });
                        
                        if (variant) {
                          formDiv.querySelector('input[name="id"]').value = variant.id;
                          
                          // Calculer la promo basée sur l'ID du produit (20-35€)
                          var promoEuros = (product.id % 15) + 20;
                          if (promoEuros > 35) promoEuros = 35;
                          
                          // Prix en euros (l'API retourne le prix en string "16.99")
                          var variantPriceEuros = parseFloat(variant.price);
                          
                          // Limiter à 45% max : promo_max = prix * 45 / 55
                          var promoMaxEuros = variantPriceEuros * 45 / 55;
                          if (promoEuros > promoMaxEuros) {
                            promoEuros = Math.floor(promoMaxEuros);
                          }
                          
                          var fakeComparePriceEuros = variantPriceEuros + promoEuros;
                          
                          // Formater les prix
                          function formatMoney(euros) {
                            return euros.toFixed(2).replace('.', ',') + '€';
                          }
                          
                          // Mettre à jour l'affichage des prix dans le header du drawer
                          var priceContainer = productDiv.querySelector('.drawer-price-container');
                          if (priceContainer) {
                            priceContainer.innerHTML = '<span class="compare-price" style="text-decoration:line-through;color:#999;margin-right:8px;">' + formatMoney(fakeComparePriceEuros) + '</span>' +
                              '<span class="price" style="color:#e53935;font-weight:600;">' + formatMoney(variantPriceEuros) + '</span>';
                          }
                          
                          // Mettre à jour le badge promo
                          var promoBadge = productDiv.querySelector('.promo-badge-drawer');
                          if (promoBadge) {
                            promoBadge.textContent = 'Économiser ' + promoEuros + '€';
                          }
                          
                          // Mettre à jour l'image si la variante a une image
                          if (variant.featured_image && variant.featured_image.src) {
                            var imgEl = productDiv.querySelector('img');
                            if (imgEl) {
                              imgEl.src = variant.featured_image.src.replace(/(\.[^.]+)$/, '_200x200$1');
                            }
                          }
                        }
                      }
                      
                      // Intercepter la soumission du formulaire
                      var form = formDiv.querySelector('form');
                      form.addEventListener('submit', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        var formData = new FormData(this);
                        var submitBtn = this.querySelector('button[name="add"]');
                        var originalText = submitBtn ? submitBtn.innerHTML : '';
                        
                        if (submitBtn) {
                          submitBtn.innerHTML = 'Ajout en cours...';
                          submitBtn.disabled = true;
                        }
                        
                        fetch('/cart/add.js', {
                          method: 'POST',
                          body: formData
                        })
                        .then(function(res) { return res.json(); })
                        .then(function(item) {
                          if (submitBtn) {
                            submitBtn.innerHTML = originalText;
                            submitBtn.disabled = false;
                          }
                          window.closeQuickDrawer();
                          
                          // Utilise showAddToCartPopup qui gère la logique homepage/collection/produit
                          showAddToCartPopup(item, title, image, price, comparePrice, hasCompare);
                        })
                        .catch(function(err) {
                          console.error('Erreur ajout panier:', err);
                          if (submitBtn) {
                            submitBtn.innerHTML = originalText;
                            submitBtn.disabled = false;
                          }
                          alert('Erreur lors de l\'ajout au panier');
                        });
                      });
                      
                  }  // Fin de displayProductForm
                  
                  // Vérifier si les données sont en cache
                  var cachedProduct = window.quickDrawerCache[url];
                  if (cachedProduct && cachedProduct !== 'loading') {
                    // Utiliser le cache - instantané!
                    displayProductForm(cachedProduct);
                  } else {
                    // Afficher le loading
                    formDiv.innerHTML = '<div class="quick-drawer-loading"><div class="loading-spinner"></div></div>';
                    
                    // Extraire le handle et faire le fetch
                    var urlParts = url.split('/');
                    var productHandle = urlParts[urlParts.indexOf('products') + 1];
                    if (productHandle && productHandle.includes('?')) {
                      productHandle = productHandle.split('?')[0];
                    }
                    
                    fetch('/products/' + productHandle + '.json')
                      .then(function(res) { return res.json(); })
                      .then(function(data) {
                        window.quickDrawerCache[url] = data.product;
                        displayProductForm(data.product);
                      })
                      .catch(function(err) {
                        console.error('Erreur:', err);
                        formDiv.innerHTML = '<p style="text-align:center;padding:20px;"><a href="' + url + '" class="button" style="display:inline-block;padding:15px 30px;background:#000;color:#fff;text-decoration:none;border-radius:4px;">Voir le produit</a></p>';
                      });
                  }
                }
                
                // Cache pour le guide des tailles
                window.sizeGuideCache = window.sizeGuideCache || {};
                
                // Fonction pour charger le guide des tailles
                window.loadSizeGuide = function(url) {
                  
                  function displayGuide(html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    
                    var sizeGuideModal = doc.getElementById('guideModal') || doc.querySelector('.guide-modal') || doc.querySelector('[id*="guide"][id*="Modal"]');
                    var sizeGuideOverlay = doc.getElementById('guideOverlay') || doc.querySelector('.guide-modal-overlay') || doc.querySelector('[id*="guide"][id*="Overlay"]');
                    
                    if (sizeGuideModal) {
                      // Supprimer les anciens
                      document.querySelectorAll('.guide-modal, #guideModal, [id*="guideModal"]').forEach(function(el) { el.remove(); });
                      document.querySelectorAll('.guide-modal-overlay, #guideOverlay, [id*="guideOverlay"]').forEach(function(el) { el.remove(); });
                      document.getElementById('guide-tailles-styles') && document.getElementById('guide-tailles-styles').remove();
                      
                      // Ajouter les styles complets - MODAL PLEIN ÉCRAN
                      var styleEl = document.createElement('style');
                      styleEl.id = 'guide-tailles-styles';
                      styleEl.textContent = `
                        .guide-modal-overlay, #guideOverlay, [id*="guideOverlay"] {
                          display: none;
                          position: fixed;
                          top: 0 !important;
                          left: 0 !important;
                          width: 100vw !important;
                          height: 100vh !important;
                          background-color: rgba(0, 0, 0, 0.7) !important;
                          z-index: 999999998 !important;
                        }
                        .guide-modal-overlay.active, #guideOverlay.active, [id*="guideOverlay"].active {
                          display: block !important;
                        }
                        .guide-modal, #guideModal, [id*="guideModal"] {
                          display: none;
                          position: fixed !important;
                          top: 2vh !important;
                          left: 2vw !important;
                          width: 96vw !important;
                          height: 96vh !important;
                          background-color: #fff !important;
                          border-radius: 12px !important;
                          z-index: 999999999 !important;
                          overflow: hidden !important;
                          box-shadow: 0 25px 80px rgba(0, 0, 0, 0.5) !important;
                        }
                        .guide-modal.active, #guideModal.active, [id*="guideModal"].active {
                          display: flex !important;
                          flex-direction: column !important;
                        }
                        .guide-modal-header {
                          padding: 15px 25px !important;
                          border-bottom: 1px solid #eee !important;
                          position: relative !important;
                          text-align: center !important;
                          background: #fff !important;
                          flex-shrink: 0 !important;
                        }
                        .guide-modal-header h3 {
                          margin: 0 0 5px 0 !important;
                          font-size: 18px !important;
                          color: #333 !important;
                          font-weight: 600 !important;
                        }
                        .guide-modal-header p {
                          margin: 0 !important;
                          font-size: 13px !important;
                          color: #888 !important;
                        }
                        .guide-modal-close {
                          position: absolute !important;
                          top: 10px !important;
                          right: 15px !important;
                          width: 36px !important;
                          height: 36px !important;
                          background: #f5f5f5 !important;
                          border: none !important;
                          border-radius: 50% !important;
                          font-size: 24px !important;
                          color: #666 !important;
                          cursor: pointer !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                        }
                        .guide-modal-close:hover {
                          background: #e0e0e0 !important;
                          color: #333 !important;
                        }
                        .guide-modal-content {
                          padding: 20px 30px !important;
                          overflow-y: auto !important;
                          flex: 1 !important;
                          -webkit-overflow-scrolling: touch !important;
                        }
                        .guide-modal-content img {
                          max-width: 100% !important;
                          height: auto !important;
                        }
                        @media (max-width: 768px) {
                          .guide-modal, #guideModal, [id*="guideModal"] {
                            top: 0 !important;
                            left: 0 !important;
                            width: 100vw !important;
                            height: 100vh !important;
                            border-radius: 0 !important;
                          }
                          .guide-modal-content {
                            padding: 15px !important;
                          }
                        }
                      `;
                      document.head.appendChild(styleEl);
                      
                      // Créer l'overlay s'il n'existe pas
                      if (!sizeGuideOverlay) {
                        var overlayDiv = document.createElement('div');
                        overlayDiv.id = 'guideOverlay';
                        overlayDiv.className = 'guide-modal-overlay';
                        document.body.appendChild(overlayDiv);
                      } else {
                        document.body.insertAdjacentHTML('beforeend', sizeGuideOverlay.outerHTML);
                      }
                      
                      // Ajouter le modal
                      document.body.insertAdjacentHTML('beforeend', sizeGuideModal.outerHTML);
                      
                      // Récupérer les éléments ajoutés
                      var modal = document.querySelector('.guide-modal, #guideModal, [id*="guideModal"]');
                      var overlay = document.querySelector('.guide-modal-overlay, #guideOverlay, [id*="guideOverlay"]');
                      
                      // Ouvrir le modal
                      if (overlay) overlay.classList.add('active');
                      if (modal) modal.classList.add('active');
                      document.body.style.overflow = 'hidden';
                      
                      // Fonction de fermeture
                      function closeGuide() {
                        if (overlay) overlay.classList.remove('active');
                        if (modal) modal.classList.remove('active');
                        document.body.style.overflow = '';
                      }
                      
                      // Attacher les événements de fermeture
                      if (overlay) overlay.onclick = closeGuide;
                      var closeBtn = modal ? modal.querySelector('.guide-modal-close, button[class*="close"], [onclick*="close"]') : null;
                      if (closeBtn) closeBtn.onclick = closeGuide;
                      
                      // Fermer avec Escape
                      var escHandler = function(e) {
                        if (e.key === 'Escape') {
                          closeGuide();
                          document.removeEventListener('keydown', escHandler);
                        }
                      };
                      document.addEventListener('keydown', escHandler);
                      
                    } else {
                      alert('Guide des tailles non disponible pour ce produit');
                    }
                  }
                  
                  // Vérifier le cache
                  if (window.sizeGuideCache[url]) {
                    displayGuide(window.sizeGuideCache[url]);
                  } else {
                    // Charger et mettre en cache
                    fetch(url)
                      .then(function(res) { return res.text(); })
                      .then(function(html) {
                        window.sizeGuideCache[url] = html;
                        displayGuide(html);
                      });
                  }
                }
                
                window.closeQuickDrawer = function() {
                  var drawer = document.getElementById('quick-drawer-global');
                  var overlay = document.getElementById('quick-drawer-overlay');
                  if (drawer) drawer.classList.remove('open');
                  if (overlay) overlay.classList.remove('open');
                  document.body.style.overflow = '';
                }
                
                // Fonction pour afficher la popup de confirmation
                function showAddToCartPopup(item, title, image, price, comparePrice, hasCompare) {
                  var path = window.location.pathname;
                  var isHomepage = (path === '/' || path === '');
                  
                  if (isHomepage) {
                    // Page d'accueil : popup classique
                    showClassicCartPopup(item, title, image, price, comparePrice, hasCompare);
                    // Rafraîchir le drawer en arrière-plan pour qu'il soit à jour quand on l'ouvre
                    refreshCartDrawerSilently();
                  } else {
                    // Collections, produits, etc. : drawer natif
                    openCartDrawerWithTimer();
                  }
                  
                  // Mettre à jour le compteur du panier
                  updateCartCount();
                }
                
                function refreshCartDrawerSilently() {
                  fetch('/?sections=cart-drawer,cart-icon-bubble')
                    .then(function(r) { return r.json(); })
                    .then(function(sections) {
                      if (sections['cart-drawer']) {
                        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                        var newContent = doc.querySelector('#CartDrawer');
                        var currentDrawer = document.getElementById('CartDrawer');
                        if (newContent && currentDrawer) {
                          currentDrawer.innerHTML = newContent.innerHTML;
                          var cartDrawer = document.querySelector('cart-drawer');
                          if (cartDrawer) {
                            // Retirer la classe is-empty pour que le CSS affiche les produits
                            cartDrawer.classList.remove('is-empty');
                            // Re-bind overlay click
                            var overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
                            if (overlay) overlay.addEventListener('click', function() { cartDrawer.close(); });
                          }
                          // Retirer is-empty sur cart-drawer-items aussi
                          var drawerItems = currentDrawer.querySelector('cart-drawer-items');
                          if (drawerItems) drawerItems.classList.remove('is-empty');
                        }
                      }
                      if (sections['cart-icon-bubble']) {
                        var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                        var newBubble = doc2.querySelector('.shopify-section');
                        var currentBubble = document.getElementById('cart-icon-bubble');
                        if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
                      }
                    })
                    .catch(function(e) { console.error('refreshCartDrawerSilently error:', e); });
                }
                
                function showClassicCartPopup(item, title, image, price, comparePrice, hasCompare) {
                  // Supprimer l'ancienne popup si elle existe
                  var oldPopup = document.getElementById('cart-confirmation-popup');
                  var oldOverlay = document.getElementById('cart-confirmation-overlay');
                  if (oldPopup) oldPopup.remove();
                  if (oldOverlay) oldOverlay.remove();
                  
                  // Créer l'overlay
                  var overlay = document.createElement('div');
                  overlay.id = 'cart-confirmation-overlay';
                  overlay.onclick = function() { closeCartPopup(); };
                  document.body.appendChild(overlay);
                  
                  // Formater le prix
                  var itemPrice = item.price ? (item.price / 100).toFixed(2).replace('.', ',') + '€' : price;
                  var itemComparePrice = item.original_price && item.original_price > item.price ? (item.original_price / 100).toFixed(2).replace('.', ',') + '€' : '';
                  var variantTitle = item.variant_title || '';
                  
                  // Créer la popup
                  var popup = document.createElement('div');
                  popup.id = 'cart-confirmation-popup';
                  popup.innerHTML = 
                    '<div class="cart-popup-header">' +
                      '<span class="cart-popup-success">✓</span> Produit ajouté au panier !' +
                    '</div>' +
                    '<div class="cart-popup-content">' +
                      '<div class="cart-popup-product">' +
                        '<img src="' + (item.image || image) + '" alt="' + title + '">' +
                        '<div class="cart-popup-details">' +
                          '<h4>' + (item.product_title || title) + '</h4>' +
                          '<div class="cart-popup-price">' +
                            (itemComparePrice ? '<span class="cart-popup-compare">' + itemComparePrice + '</span> ' : '') +
                            '<span class="cart-popup-current">' + itemPrice + '</span>' +
                          '</div>' +
                          (variantTitle ? '<p class="cart-popup-variant">' + variantTitle + '</p>' : '') +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                    '<div class="cart-popup-buttons">' +
                      '<a href="/cart" class="cart-popup-btn cart-popup-btn-secondary">PANIER</a>' +
                      '<a href="/checkout" class="cart-popup-btn cart-popup-btn-primary">COMPLÉTEZ VOTRE COMMANDE</a>' +
                    '</div>' +
                    '<button type="button" class="cart-popup-close" onclick="closeCartPopup()">&times;</button>';
                  
                  document.body.appendChild(popup);
                  
                  // Animer l'apparition
                  setTimeout(function() {
                    overlay.classList.add('active');
                    popup.classList.add('active');
                  }, 10);
                }
                
                function openCartDrawerWithTimer() {
                  // Ouvrir le drawer NATIF du thème Lumin
                  var cartDrawer = document.querySelector('cart-drawer');
                  if (!cartDrawer) {
                    window.location.href = '/cart';
                    return;
                  }
                  
                  // Rafraîchir le contenu du drawer puis l'ouvrir
                  fetch('/?sections=cart-drawer,cart-icon-bubble')
                    .then(function(r) { return r.json(); })
                    .then(function(sections) {
                      if (sections['cart-drawer']) {
                        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                        var newContent = doc.querySelector('#CartDrawer');
                        var currentDrawer = document.getElementById('CartDrawer');
                        if (newContent && currentDrawer) {
                          currentDrawer.innerHTML = newContent.innerHTML;
                          var overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
                          if (overlay) overlay.addEventListener('click', function() { cartDrawer.close(); });
                        }
                      }
                      if (sections['cart-icon-bubble']) {
                        var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                        var newBubble = doc2.querySelector('.shopify-section');
                        var currentBubble = document.getElementById('cart-icon-bubble');
                        if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
                      }
                      cartDrawer.open();
                    })
                    .catch(function() { cartDrawer.open(); });
                }
                
                // Créer la structure du drawer personnalisé
                function createCustomCartDrawer() {
                  // Styles
                  var style = document.createElement('style');
                  style.id = 'custom-cart-drawer-styles';
                  style.textContent = `
                    #custom-cart-drawer-overlay {
                      position: fixed;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      background: rgba(0,0,0,0.5);
                      z-index: 999998;
                      opacity: 0;
                      visibility: hidden;
                      transition: opacity 0.3s, visibility 0.3s;
                    }
                    #custom-cart-drawer-overlay.open {
                      opacity: 1;
                      visibility: visible;
                    }
                    #custom-cart-drawer {
                      position: fixed;
                      top: 0;
                      right: 0;
                      width: 420px;
                      max-width: 90vw;
                      height: 100%;
                      background: #fff;
                      z-index: 999999;
                      transform: translateX(100%);
                      transition: transform 0.3s ease;
                      display: flex;
                      flex-direction: column;
                      box-shadow: -5px 0 25px rgba(0,0,0,0.15);
                    }
                    #custom-cart-drawer.open {
                      transform: translateX(0);
                    }
                    .custom-cart-header {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      padding: 15px 20px;
                      border-bottom: 1px solid #e5e5e5;
                      background: #fff;
                    }
                    .custom-cart-header h2 {
                      margin: 0;
                      font-size: 18px;
                      font-weight: 600;
                    }
                    .custom-cart-close {
                      background: none;
                      border: none;
                      font-size: 28px;
                      cursor: pointer;
                      padding: 0;
                      line-height: 1;
                      color: #333;
                    }
                    .custom-cart-timer {
                      background: #e8f5e9;
                      color: #2e7d32;
                      padding: 12px 15px;
                      text-align: center;
                      font-size: 14px;
                      font-weight: 500;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 8px;
                      border-bottom: 1px solid #c8e6c9;
                    }
                    .custom-cart-timer .timer-icon {
                      font-size: 16px;
                    }
                    .custom-cart-timer .timer-countdown {
                      font-weight: 700;
                      font-size: 15px;
                    }
                    .custom-cart-items {
                      flex: 1;
                      overflow-y: auto;
                      padding: 15px;
                    }
                    .custom-cart-item {
                      display: flex;
                      gap: 15px;
                      padding: 15px 0;
                      border-bottom: 1px solid #eee;
                    }
                    .custom-cart-item:last-child {
                      border-bottom: none;
                    }
                    .custom-cart-item img {
                      width: 80px;
                      height: 80px;
                      object-fit: cover;
                      border-radius: 8px;
                      border: 1px solid #eee;
                    }
                    .custom-cart-item-details {
                      flex: 1;
                      display: flex;
                      flex-direction: column;
                      gap: 5px;
                    }
                    .custom-cart-item-title {
                      font-weight: 600;
                      font-size: 14px;
                      color: #333;
                      margin: 0;
                    }
                    .custom-cart-item-variant {
                      font-size: 12px;
                      color: #666;
                      margin: 0;
                    }
                    .custom-cart-item-price {
                      font-size: 14px;
                      margin-top: auto;
                    }
                    .custom-cart-item-price .compare-price {
                      text-decoration: line-through;
                      color: #999;
                      margin-right: 8px;
                      font-size: 13px;
                    }
                    .custom-cart-item-price .current-price {
                      font-weight: 600;
                      color: #000;
                    }
                    .custom-cart-item-qty {
                      font-size: 13px;
                      color: #666;
                    }
                    .custom-cart-item-info {
                      flex: 1;
                      min-width: 0;
                    }
                    .custom-cart-item-prices {
                      display: flex;
                      align-items: center;
                      gap: 8px;
                    }
                    .custom-cart-item-price {
                      font-size: 14px;
                      font-weight: 600;
                      color: #000;
                    }
                    .custom-cart-item-compare {
                      font-size: 13px;
                      color: #999;
                      text-decoration: line-through;
                    }
                    .custom-cart-item-badge {
                      display: inline-block;
                      background: #e8f5e9;
                      color: #2e7d32;
                      font-size: 11px;
                      padding: 2px 8px;
                      border-radius: 4px;
                      margin-top: 5px;
                    }
                    .custom-cart-item-actions {
                      display: flex;
                      flex-direction: column;
                      align-items: flex-end;
                      gap: 8px;
                      flex-shrink: 0;
                    }
                    .custom-cart-qty {
                      display: flex;
                      align-items: center;
                      gap: 8px;
                    }
                    .custom-cart-qty button {
                      width: 26px;
                      height: 26px;
                      border: 1px solid #ddd;
                      background: #fff;
                      border-radius: 50%;
                      font-size: 16px;
                      cursor: pointer;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #666;
                      transition: all 0.2s;
                    }
                    .custom-cart-qty button:hover {
                      background: #f0f0f0;
                      border-color: #999;
                    }
                    .custom-cart-qty span {
                      font-size: 14px;
                      min-width: 20px;
                      text-align: center;
                    }
                    .custom-cart-remove {
                      background: none;
                      border: none;
                      color: #999;
                      font-size: 12px;
                      cursor: pointer;
                      text-decoration: underline;
                      padding: 0;
                    }
                    .custom-cart-remove:hover {
                      color: #666;
                    }
                    .custom-cart-empty {
                      text-align: center;
                      padding: 40px 20px;
                      color: #666;
                    }
                    .custom-cart-recommendations {
                      padding: 15px;
                      border-top: 1px solid #eee;
                      background: #f9f9f9;
                    }
                    .custom-cart-recommendations h3 {
                      font-size: 14px;
                      font-weight: 600;
                      margin: 0 0 12px 0;
                      color: #333;
                    }
                    .custom-cart-reco-slider {
                      display: flex;
                      gap: 10px;
                      overflow-x: auto;
                      scroll-snap-type: x mandatory;
                      -webkit-overflow-scrolling: touch;
                      padding-bottom: 8px;
                    }
                    .custom-cart-reco-slider::-webkit-scrollbar {
                      height: 4px;
                    }
                    .custom-cart-reco-slider::-webkit-scrollbar-track {
                      background: #eee;
                      border-radius: 2px;
                    }
                    .custom-cart-reco-slider::-webkit-scrollbar-thumb {
                      background: #ccc;
                      border-radius: 2px;
                    }
                    .custom-cart-reco-item {
                      flex: 0 0 auto;
                      width: 120px;
                      scroll-snap-align: start;
                      background: #fff;
                      border-radius: 8px;
                      border: 1px solid #eee;
                      padding: 8px;
                      text-decoration: none;
                      color: inherit;
                      transition: box-shadow 0.2s;
                    }
                    .custom-cart-reco-item:hover {
                      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    .custom-cart-reco-item img {
                      width: 100%;
                      height: 80px;
                      object-fit: contain;
                      border-radius: 4px;
                      margin-bottom: 6px;
                    }
                    .custom-cart-reco-title {
                      font-size: 11px;
                      font-weight: 500;
                      line-height: 1.3;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      margin-bottom: 4px;
                    }
                    .custom-cart-reco-price {
                      font-size: 12px;
                      font-weight: 600;
                    }
                    .custom-cart-reco-price .compare {
                      text-decoration: line-through;
                      color: #999;
                      font-weight: 400;
                      margin-right: 4px;
                    }
                    .custom-cart-reco-btn {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      width: 28px;
                      height: 28px;
                      background: #000;
                      color: #fff;
                      border: none;
                      border-radius: 50%;
                      font-size: 16px;
                      cursor: pointer;
                      margin-top: 6px;
                      margin-left: auto;
                    }
                    .custom-cart-footer {
                      background: #1a1a1a;
                      padding: 0;
                      flex-shrink: 0;
                    }
                    .custom-cart-checkout-btn {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 12px;
                      width: 100%;
                      padding: 16px 20px;
                      background: #1a1a1a;
                      color: #fff;
                      text-decoration: none;
                      font-size: 13px;
                      font-weight: 600;
                      text-transform: uppercase;
                      letter-spacing: 0.5px;
                    }
                    .custom-cart-checkout-btn:hover {
                      background: #333;
                      color: #fff;
                    }
                    .custom-cart-checkout-btn .cart-icon {
                      font-size: 16px;
                    }
                    .custom-cart-checkout-btn .cart-total {
                      margin-left: auto;
                    }
                    .custom-cart-savings-bar {
                      background: linear-gradient(90deg, #22c55e, #16a34a);
                      color: #fff;
                      padding: 12px 15px;
                      text-align: center;
                      font-size: 14px;
                      font-weight: 500;
                      flex-shrink: 0;
                    }
                  `;
                  document.head.appendChild(style);
                  
                  // Overlay
                  var overlay = document.createElement('div');
                  overlay.id = 'custom-cart-drawer-overlay';
                  overlay.onclick = closeCustomCartDrawer;
                  document.body.appendChild(overlay);
                  
                  // Drawer
                  var drawer = document.createElement('div');
                  drawer.id = 'custom-cart-drawer';
                  drawer.innerHTML = `
                    <div class="custom-cart-header">
                      <h2>Mon Panier</h2>
                      <button class="custom-cart-close" onclick="closeCustomCartDrawer()">&times;</button>
                    </div>
                    <div class="custom-cart-timer">
                      <span class="timer-icon">⏱</span> 
                      Votre panier expirera dans 
                      <span class="timer-countdown">10:00</span>
                    </div>
                    <div class="custom-cart-items">
                      <!-- Contenu dynamique -->
                    </div>
                    <div class="custom-cart-recommendations">
                      <h3>VOUS POURRIEZ AUSSI AIMER</h3>
                      <div class="custom-cart-reco-slider" id="custom-cart-reco-slider">
                        <!-- Produits chargés dynamiquement -->
                      </div>
                    </div>
                    <div class="custom-cart-savings-bar" id="custom-cart-savings-bar" style="display:none;">
                      Vous économisez <span id="custom-cart-total-savings">0,00€</span> sur votre commande
                    </div>
                    <div class="custom-cart-footer">
                      <a href="/checkout" class="custom-cart-checkout-btn">
                        <span class="cart-icon">🛒</span>
                        <span>PROCÉDER AU PAIEMENT</span>
                        <span>■</span>
                        <span class="cart-total" id="custom-cart-total-price">0,00€ EUR</span>
                      </a>
                    </div>
                  `;
                  document.body.appendChild(drawer);
                  
                  // Charger les produits recommandés
                  loadRecommendedProducts();
                }
                
                // Afficher le contenu du panier
                function renderCustomCartDrawer(cart) {
                  var itemsContainer = document.querySelector('#custom-cart-drawer .custom-cart-items');
                  var footerEl = document.querySelector('#custom-cart-drawer .custom-cart-footer');
                  var headerEl = document.querySelector('#custom-cart-drawer .custom-cart-header h2');
                  
                  if (!itemsContainer) return;
                  
                  // Mettre à jour le titre avec le nombre d'articles
                  if (headerEl) {
                    headerEl.textContent = 'Mon Panier (' + cart.item_count + ')';
                  }
                  
                  if (cart.items.length === 0) {
                    itemsContainer.innerHTML = '<div class="custom-cart-empty"><p>Votre panier est vide</p></div>';
                    if (footerEl) footerEl.style.display = 'none';
                    var savingsBar = document.getElementById('custom-cart-savings-bar');
                    if (savingsBar) savingsBar.style.display = 'none';
                    return;
                  }
                  
                  if (footerEl) footerEl.style.display = 'block';
                  
                  var html = '';
                  var totalSavings = 0;
                  
                  cart.items.forEach(function(item) {
                    var unitPrice = (item.final_price / 100).toFixed(2).replace('.', ',');
                    var linePrice = (item.final_line_price / 100).toFixed(2).replace('.', ',');
                    var comparePrice = '';
                    var savings = 0;
                    
                    if (item.original_line_price > item.final_line_price) {
                      comparePrice = (item.original_price / 100).toFixed(2).replace('.', ',');
                      savings = item.original_line_price - item.final_line_price;
                      totalSavings += savings;
                    }
                    
                    var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
                    var savingsBadge = savings > 0 ? '<span class="custom-cart-item-badge">Économie: -' + (savings / 100).toFixed(2).replace('.', ',') + '€</span>' : '';
                    
                    html += `
                      <div class="custom-cart-item" data-key="${item.key}">
                        <img src="${item.image || '/no-image.jpg'}" alt="${item.product_title}">
                        <div class="custom-cart-item-info">
                          <p class="custom-cart-item-title">${item.product_title}</p>
                          ${variantTitle ? '<p class="custom-cart-item-variant">' + variantTitle + '</p>' : ''}
                          <div class="custom-cart-item-prices">
                            <span class="custom-cart-item-price">${unitPrice}€</span>
                            ${comparePrice ? '<span class="custom-cart-item-compare">' + comparePrice + '€</span>' : ''}
                          </div>
                          ${savingsBadge}
                        </div>
                        <div class="custom-cart-item-actions">
                          <div class="custom-cart-qty">
                            <button onclick="updateCartQty('${item.key}', ${item.quantity - 1})">−</button>
                            <span>${item.quantity}</span>
                            <button onclick="updateCartQty('${item.key}', ${item.quantity + 1})">+</button>
                          </div>
                          <button class="custom-cart-remove" onclick="updateCartQty('${item.key}', 0)">Retirer</button>
                        </div>
                      </div>
                    `;
                  });
                  
                  itemsContainer.innerHTML = html;
                  
                  // Calculer les économies totales
                  var cartSavings = 0;
                  if (cart.original_total_price && cart.original_total_price > cart.total_price) {
                    cartSavings = cart.original_total_price - cart.total_price;
                  }
                  if (cartSavings === 0 && totalSavings > 0) {
                    cartSavings = totalSavings;
                  }
                  
                  // Afficher les économies dans la barre en bas
                  var savingsBar = document.getElementById('custom-cart-savings-bar');
                  var savingsAmount = document.getElementById('custom-cart-total-savings');
                  if (cartSavings > 0 && savingsBar && savingsAmount) {
                    savingsAmount.textContent = (cartSavings / 100).toFixed(2).replace('.', ',') + '€';
                    savingsBar.style.display = 'block';
                  } else if (savingsBar) {
                    savingsBar.style.display = 'none';
                  }
                  
                  // Mettre à jour le footer avec le total
                  var totalEl = document.getElementById('custom-cart-total-price');
                  if (totalEl) {
                    totalEl.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + '€ EUR';
                  }
                  
                  // Démarrer le timer
                  startCustomCartTimer();
                }
                
                // Mettre à jour la quantité d'un article
                window.updateCartQty = function(key, qty) {
                  fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: key, quantity: qty })
                  })
                  .then(function(res) { return res.json(); })
                  .then(function(cart) {
                    renderCustomCartDrawer(cart);
                    updateCartCount();
                  })
                  .catch(function(err) {
                    console.error('Erreur update qty:', err);
                  });
                };
                
                // Ouvrir le drawer
                function openCustomCartDrawer() {
                  var drawer = document.getElementById('custom-cart-drawer');
                  var overlay = document.getElementById('custom-cart-drawer-overlay');
                  if (drawer) drawer.classList.add('open');
                  if (overlay) overlay.classList.add('open');
                  document.body.style.overflow = 'hidden';
                }
                
                // Fermer le drawer
                window.closeCustomCartDrawer = function() {
                  var drawer = document.getElementById('custom-cart-drawer');
                  var overlay = document.getElementById('custom-cart-drawer-overlay');
                  if (drawer) drawer.classList.remove('open');
                  if (overlay) overlay.classList.remove('open');
                  document.body.style.overflow = '';
                }
                
                // Intercepter le clic sur l'icône panier du header
                document.addEventListener('DOMContentLoaded', function() {
                  setTimeout(function() {
                    // Le clic sur l'icône panier est géré par le cart-drawer natif du thème
                    // On n'intercepte pas #cart-icon-bubble pour ne pas interférer
                    
                    // Intercepter les formulaires d'ajout au panier
                    // SAUF ceux déjà gérés par product-form.js (dans <product-form>)
                    var productForms = document.querySelectorAll('form[action="/cart/add"], product-form form, .product-form form, .shopify-product-form');
                    
                    productForms.forEach(function(form) {
                      // Ne pas intercepter si déjà dans un <product-form> custom element
                      if (form.closest('product-form')) return;
                      
                      form.addEventListener('submit', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        var formData = new FormData(form);
                        
                        fetch('/cart/add.js', {
                          method: 'POST',
                          body: formData
                        })
                        .then(function(res) { return res.json(); })
                        .then(function(item) {
                          console.log('Produit ajouté:', item);
                          updateCartCount();
                          openCartDrawerWithTimer();
                        })
                        .catch(function(err) {
                          console.error('Erreur ajout panier:', err);
                          // Fallback: soumettre le formulaire normalement
                          form.submit();
                        });
                      });
                    });
                  }, 500);
                });
                
                // Timer personnalisé
                var customCartTimerInterval = null;
                function startCustomCartTimer() {
                  if (customCartTimerInterval) clearInterval(customCartTimerInterval);
                  
                  var timeLeft = 10 * 60; // 10 minutes
                  
                  // Récupérer le temps sauvegardé
                  var savedTime = localStorage.getItem('cartTimerEnd');
                  if (savedTime) {
                    var endTime = parseInt(savedTime);
                    var now = Date.now();
                    if (endTime > now) {
                      timeLeft = Math.floor((endTime - now) / 1000);
                    } else {
                      localStorage.setItem('cartTimerEnd', Date.now() + (timeLeft * 1000));
                    }
                  } else {
                    localStorage.setItem('cartTimerEnd', Date.now() + (timeLeft * 1000));
                  }
                  
                  var timerEl = document.querySelector('#custom-cart-drawer .timer-countdown');
                  
                  function updateTimer() {
                    if (timeLeft <= 0) {
                      clearInterval(customCartTimerInterval);
                      if (timerEl) timerEl.textContent = '0:00';
                      return;
                    }
                    
                    var minutes = Math.floor(timeLeft / 60);
                    var seconds = timeLeft % 60;
                    if (timerEl) {
                      timerEl.textContent = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
                    }
                    timeLeft--;
                  }
                  
                  updateTimer();
                  customCartTimerInterval = setInterval(updateTimer, 1000);
                }
                
                // Charger les produits recommandés de la collection accessoires-maison
                function loadRecommendedProducts() {
                  var slider = document.getElementById('custom-cart-reco-slider');
                  if (!slider) return;
                  
                  // Charger la collection accessoires-maison
                  fetch('/collections/accessoires-maison/products.json?limit=10')
                    .then(function(res) { return res.json(); })
                    .then(function(data) {
                      if (!data.products || data.products.length === 0) {
                        // Fallback: cacher la section si pas de produits
                        var recoSection = document.querySelector('.custom-cart-recommendations');
                        if (recoSection) recoSection.style.display = 'none';
                        return;
                      }
                      
                      var html = '';
                      data.products.forEach(function(product) {
                        var image = product.images && product.images[0] ? product.images[0].src : '/no-image.jpg';
                        var price = (product.variants[0].price / 1).toFixed(2).replace('.', ',');
                        var comparePrice = product.variants[0].compare_at_price ? (product.variants[0].compare_at_price / 1).toFixed(2).replace('.', ',') : '';
                        var variantId = product.variants[0].id;
                        
                        html += `
                          <div class="custom-cart-reco-item">
                            <a href="/products/${product.handle}">
                              <img src="${image}" alt="${product.title}">
                            </a>
                            <div class="custom-cart-reco-title">${product.title}</div>
                            <div class="custom-cart-reco-price">
                              ${comparePrice ? '<span class="compare">' + comparePrice + '€</span>' : ''}
                              ${price}€
                            </div>
                            <button class="custom-cart-reco-btn" onclick="addRecoToCart(${variantId})" title="Ajouter au panier">+</button>
                          </div>
                        `;
                      });
                      
                      slider.innerHTML = html;
                    })
                    .catch(function(err) {
                      console.error('Erreur chargement recommandations:', err);
                      var recoSection = document.querySelector('.custom-cart-recommendations');
                      if (recoSection) recoSection.style.display = 'none';
                    });
                }
                
                // Ajouter un produit recommandé au panier
                window.addRecoToCart = function(variantId) {
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: variantId,
                      quantity: 1
                    })
                  })
                  .then(function(res) { return res.json(); })
                  .then(function(item) {
                    // Recharger le contenu du drawer
                    fetch('/cart.js')
                      .then(function(res) { return res.json(); })
                      .then(function(cart) {
                        renderCustomCartDrawer(cart);
                        updateCartCount();
                      });
                  })
                  .catch(function(err) {
                    console.error('Erreur ajout produit:', err);
                  });
                };
                
                // Compte à rebours du panier
                var cartCountdownInterval = null;
                function startCartCountdown() {
                  // Annuler le timer précédent
                  if (cartCountdownInterval) clearInterval(cartCountdownInterval);
                  
                  // 10 minutes en secondes
                  var timeLeft = 10 * 60;
                  
                  // Stocker le temps de début
                  var savedTime = localStorage.getItem('cartTimerEnd');
                  if (savedTime) {
                    var endTime = parseInt(savedTime);
                    var now = Date.now();
                    if (endTime > now) {
                      timeLeft = Math.floor((endTime - now) / 1000);
                    } else {
                      localStorage.setItem('cartTimerEnd', Date.now() + (timeLeft * 1000));
                    }
                  } else {
                    localStorage.setItem('cartTimerEnd', Date.now() + (timeLeft * 1000));
                  }
                  
                  function updateTimer() {
                    var minutes = Math.floor(timeLeft / 60);
                    var seconds = timeLeft % 60;
                    var display = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
                    
                    var timerEl = document.querySelector('.timer-countdown');
                    if (timerEl) {
                      timerEl.textContent = display;
                    }
                    
                    if (timeLeft <= 0) {
                      clearInterval(cartCountdownInterval);
                      localStorage.removeItem('cartTimerEnd');
                    } else {
                      timeLeft--;
                    }
                  }
                  
                  updateTimer();
                  cartCountdownInterval = setInterval(updateTimer, 1000);
                }
                
                window.closeCartPopup = function() {
                  var popup = document.getElementById('cart-confirmation-popup');
                  var overlay = document.getElementById('cart-confirmation-overlay');
                  if (popup) popup.classList.remove('active');
                  if (overlay) overlay.classList.remove('active');
                  setTimeout(function() {
                    if (popup) popup.remove();
                    if (overlay) overlay.remove();
                  }, 300);
                }
                
                function updateCartCount() {
                  fetch('/cart.js')
                    .then(function(res) { return res.json(); })
                    .then(function(cart) {
                      var counters = document.querySelectorAll('.cart-count-bubble span, .cart-count, [data-cart-count]');
                      counters.forEach(function(counter) {
                        counter.textContent = cart.item_count;
                      });
                    });
                }
                } // fin du if typeof
